import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SetupStep, setupBuildingsPath, setupDevicesPath } from "./setupRoutes";

export const SETUP_STEPS: { step: SetupStep; labelKey: string }[] = [
  // i18n.t("setup-step-breeding")
  { step: 1, labelKey: "setup-step-breeding" },
  // i18n.t("setup-step-buildings")
  { step: 2, labelKey: "setup-step-buildings" },
  // i18n.t("setup-step-devices")
  { step: 3, labelKey: "setup-step-devices" },
  // i18n.t("setup-step-summary")
  { step: 4, labelKey: "setup-step-summary" },
];

/**
 * Progression du parcours. Les étapes 2 et 3 sont cliquables une fois franchies — on y
 * revient pour ajouter un bâtiment ou un produit. L'étape 1 ne l'est jamais : y retourner
 * créerait un second élevage au lieu de modifier le premier.
 */
export const SetupStepBar = ({
  current,
  breedingId,
}: {
  current: SetupStep;
  breedingId?: number;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const pathFor = (step: SetupStep) => {
    if (!breedingId || step >= current) return undefined;
    if (step === 2) return setupBuildingsPath(breedingId);
    if (step === 3) return setupDevicesPath(breedingId);
    return undefined;
  };

  return (
    <ol className="flex flex-wrap gap-2">
      {SETUP_STEPS.map(({ step, labelKey }) => {
        const done = step < current;
        const active = step === current;
        const path = pathFor(step);

        return (
          <li key={step} className="flex-1 min-w-[7rem]">
            <button
              type="button"
              disabled={!path}
              onClick={() => path && navigate(path)}
              aria-current={active ? "step" : undefined}
              className={`w-full text-left border-t-4 pt-2 transition-opacity ${
                active || done ? "border-tertiary" : "border-tertiary/30"
              } ${path ? "hover:opacity-70" : "cursor-default"}`}
            >
              <span
                className={`block text-xs font-oxaniumMedium ${
                  active || done ? "text-tertiary" : "text-tertiary/50"
                }`}
              >
                {step}
              </span>
              <span
                className={`block text-sm font-oxaniumMedium ${
                  active ? "text-tertiary" : "text-tertiary/60"
                }`}
              >
                {t(labelKey)}
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  );
};
